import { memo } from "react";
import { TableGridMode } from "consts/table";
import { Filters } from "consts/consumers";
import { formatters } from "ui/widgets/Table";
import ConsumersTable from "ui/organizms/Consumers/ConsumerTable";
import useActiveConsumers from "./useActiveConsumers";

const ActiveConsumersTable = () => {
    const {
        getActiveConsumers,
        downloadActiveConsumers
    } = useActiveConsumers();

    return (
        <ConsumersTable
            mode={TableGridMode.ActiveConsumer}
            fetchTableData={getActiveConsumers}
            downloadCsv={downloadActiveConsumers}
            columns={[
                {
                    field: Filters.rejectionRate,
                    headerName: 'Rejection rate',
                    description: 'The ratio of rejected transactions to total transactions (Number of rejected transactions / Number of total transactions)',
                    minWidth: 150,
                    align: 'center',
                    headerAlign: 'center',
                    valueGetter: ({ row, ...restProps }) => formatters.percentage()({
                        ...restProps,
                        value: (row.rejectedTransactions_count / row.parentTransactions_count)
                    })
                }
            ]}
        />
    );
};

export default memo(ActiveConsumersTable);
